<template>
  <div>
    <SearchFilters
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      @branchChange="handleBranchChange"
      @update:searchQuery="searchQuery = $event"
    />
    <b-row>
      <b-col cols="12" md="6">
        <UserSettings />
      </b-col>
      <b-col cols="12" md="6">
        <FormGenerator :Fields="Fields" :model="data" :options="options"/>
        <div class="text-right">
          <b-button variant="primary" type="warning" native-type="submit" >Submit</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SearchFilters from "@/components/SearchFilters.vue";
import { Fields, models, options } from "./form_fields";
import { listBranchSetting, setBranchSetting } from "@/API/BranchesAPIs";
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { AppSettings } from "@/config/constant";
import UserSettings from "./UserSettings.vue";

export default {
  name: "AccountSettingsTab",
  props: ["id", "model"],
  components: {
    SearchFilters,
    FormGenerator,
    UserSettings
  },
  data() {
    return {
      businessId: null,
      branchId: null,
      showSearchBox: false,
      data: JSON.parse(JSON.stringify(models)),
      options: options,
      Fields: Fields,
      emptyModel: null,
      inList: false,
      rules: {
        Address: [
          { required: true, message: "Please enter the name", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    filteredLocalizedItems() {
      return this.items
        .map(item => {
          const localizedData =
            item.locales.find(locale => locale.locale === this.currentLocale) ||
            item.locales[0];
          return {
            ...item,
            name: localizedData.name || "",
            description: localizedData.description || ""
          };
        })
        .filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.userBusinesses.find(b => b.id === this.businessId)?.branches || [];
    }
  },
  watch: {
    businessId(newBusinessID) {
      const business = this.userBusinesses.find(b => b.id === newBusinessID);
      this.branchId = business?.branches?.[0]?.id || null;
    },
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
        }
      },
      deep: true
    },
    userBranches: {
      handler(newBranches) {
        if (newBranches.length > 0 && !this.branchId) {
          this.branchId = newBranches[0].id;
          if (this.branchId && this.businessId) {}
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    handleBranchChange(newValue) {
      if (newValue !== this.branchId) {
        this.branchId = newValue;
      }
    },
    async resetForm() {
      this.data = JSON.parse(this.emptyModel);
      await this.getData();
    },
    async getData() {
      this.data = { ...JSON.parse(this.emptyModel) };
      let settingData = await listBranchSetting({
        businessId: this.businessId,
        branchId: this.branchId
      });
      let tabletSettings = _.filter(settingData, {
        key: AppSettings.TabletAppSettings
      });
      if (tabletSettings && tabletSettings.length)
        tabletSettings[0]?.data?.forEach(set => {
          this.data[set.key] = set.data;
        });
    },
    modelToSubmitDataConverter() {
      var data = [];
      for (const [key, value] of Object.entries(this.data)) {
        if (value !== null && value !== "" && key !== null && key !== "") {
          data.push({ key: key, data: value });
        }
      }
      return [{ key: AppSettings.TabletAppSettings, data }];
    },
    async submit() {
      const loader = this.$loading.show();
      let submitData = this.modelToSubmitDataConverter();
      await setBranchSetting(
        this.businessId,
        this.branchId,
        submitData
      );
      loader.hide();
    }
  }
};
</script>

<style scoped></style>
